import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/uptime/editPublic/uptime.editPublic.delete.mutation.gql"
import { UPTIME_CONFIG_REFETCH_QUERIES } from "@/v2-backoffice-client/uptime/config/uptime.config.query"
import type {
  UptimeEditPublicDeleteMutation,
  UptimeEditPublicDeleteMutationVariables,
} from "@/v2-backoffice-client/uptime/editPublic/__types__/uptime.editPublic.delete.mutation"

type Options = MutationHookOptions<
  UptimeEditPublicDeleteMutation,
  UptimeEditPublicDeleteMutationVariables
>

// useUptimeEditPublicDeleteMutation deletes the per-target row in
// status.TargetOverrides so the public page falls back to the
// config-derived defaults. Same refetch behaviour as upsert: we
// refetch the long-cached config query so the form immediately
// re-mounts against the seed defaults.
export function useUptimeEditPublicDeleteMutation(options?: Options) {
  return useMutation<
    UptimeEditPublicDeleteMutation,
    UptimeEditPublicDeleteMutationVariables
  >(mutation, {
    refetchQueries: [...UPTIME_CONFIG_REFETCH_QUERIES],
    awaitRefetchQueries: true,
    ...options,
  })
}
